import React from 'react';
import { Label, Icon } from 'semantic-ui-react';
import Moment from 'react-moment';
import { withCookies } from 'react-cookie';

const MutationInfo = (props) => {
  const { when, who, cookies } = props;
  
  return (
    !!when && !!who &&
      <Label size='small' basic>
        <Icon name='add user' />
        <Label.Detail>
          <Moment locale={cookies.get('lang') || 'et'}>{when}</Moment> ({who.substr(0,8)})
        </Label.Detail>
      </Label>
  );
};
      

export default withCookies(MutationInfo);



// WEBPACK FOOTER //
// ./src/private/common/components/MutationInfo/index.js